import {resetTooltip} from "./Utils.js";

export default class Modal
{
    constructor(classes) {
        BS_EVENTS.active_modal = this;
        BS_EVENTS.was_quick_menu_visible = document.getElementById('quick-menu').classList.contains('show');

        this.controller = new AbortController();
        this.signal = this.controller.signal;

        const modalTemplate = document.getElementById('modal-template').content;
        this.modalTemplate = modalTemplate.firstElementChild.cloneNode(true);
        this.template = null;
        this.body = null;

        if (typeof classes !== 'undefined') {
            classes.split(',').forEach(i => this.modalTemplate.classList.add(i.trim()));
        }

        this.modalTemplate.addEventListener('click', e => {
           if (e.target.matches('.modal')) {
               this.close();
           }

           if (e.target.matches('#modal-close')) {
               this.close();
           }
        }, { signal: this.signal });

        this.modalTemplate.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                this.close();
            }
        }, { signal: this.signal });

        this.modalTemplate.addEventListener('submit', e => e.preventDefault());
    }

    onOpen(template, callback) {
        this.template = document.getElementById(template).content;
        this.body = this.template.cloneNode(true);
        this.onOpenCallback = callback;
    }

    open(title) {
        if (BS_EVENTS.was_quick_menu_visible) {
            document.getElementById('quick-menu').classList.remove('show');
        }

        if (typeof title !== 'undefined') {
            this.modalTemplate.querySelector('.modal__header').textContent = title;
        }

        this.modalTemplate.querySelector('.modal__body').appendChild(this.body);

        this.modalTemplate.addEventListener('keydown', e => {
            if (e.key === 'Enter' && !this.modalTemplate.querySelector('textarea')) {
                this.modalTemplate.querySelector('.button--success:not(.button--disabled)')?.click();
            }
        }, { signal: this.signal });

        const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement;
        const activeContainer = fullscreenElement || document.body;

        if (this.modalTemplate.parentElement !== activeContainer) {
            activeContainer.appendChild(this.modalTemplate);
        } else {
            document.body.appendChild(this.modalTemplate);
        }

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                document.body.classList.add('modal--opened');
            });
        });

        this.modalTemplate.addEventListener('transitionend', () => {
            const inputField = this.modalTemplate.querySelector('input:not([readonly])');

            if (inputField) {
                if (!inputField.closest('.action__bar')) {
                    inputField.focus();
                }
            } else {
                this.modalTemplate.focus();
            }
        }, { once: true });

        if (typeof this.onOpenCallback !== 'undefined') {
            this.onOpenCallback(this.modalTemplate, this.signal);
        }

        __All(this.modalTemplate);
    }

    onClose(callback) {
        this.onCloseCallback = callback;
    }

    close() {
        this.controller.abort();
        document.body.classList.remove('modal--opened');
        this.modalTemplate.remove();

        if (typeof this.onCloseCallback !== 'undefined') {
            this.onCloseCallback();
        }

        if (BS_EVENTS.was_quick_menu_visible) {
            document.getElementById('quick-menu').classList.add('show');
        }

        BS_EVENTS.active_modal = undefined;
        delete BS_EVENTS.was_quick_menu_visible;

        // reset tooltip
        resetTooltip();
    }
}